module.exports = __webpack_public_path__ + "static/img/zkBack.12cfeeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sanboIcon/zkBack.png
// module id = BbuV
// module chunks = 248